import React from 'react';

class JQueryTableComponent extends React.Component {
  generateRow(row) {
    const html = [];
    row.forEach((item, index) => {
      if (row.length - 1 !== index) {
        html.push(
          <th key={item}>{item}</th>
        );
      } else {
        html.push(
          <th className="disabled-sorting text-right" style={{ textAlign: 'end'}} key={item}>
            {item}
          </th>
        );
      }
    });
    return html;
  };
  render() {
    return(
      <table
        id={this.props.identifier}
        ref="main"
        className="table table-striped table-no-bordered table-hover"
        cellSpacing="0"
        width="100%"
        style={{
          width: "100%"
        }}
      >
        <thead>
          <tr>
            {this.generateRow(this.props.dataTable.headerRow)}
          </tr>
        </thead>
        <tfoot>
          <tr>
            {this.generateRow(this.props.dataTable.footerRow)}
          </tr>
        </tfoot>
        <tbody />
      </table>
    );
  }
}

export default JQueryTableComponent;



// WEBPACK FOOTER //
// ./src/views/Components/JQueryTable/JQueryTableComponent.jsx